// Shared by the forms in the browser and the API routes on the server,
// so both sides apply exactly the same rules.

export const FIELD_LIMITS = {
    name: 100,
    email: 254,
    message: 5000
} as const

export const MESSAGE_MIN_LENGTH = 10

const EMAIL_PATTERN = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/

export const isValidEmail = (value: string): boolean => value.length <= FIELD_LIMITS.email && EMAIL_PATTERN.test(value)

// Trims, drops control characters and caps the length of anything a visitor typed.
export const cleanText = (value: unknown, maxLength: number, { singleLine = false } = {}): string => {
    if (typeof value !== 'string') return ''

    const withoutControls = value.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '')
    const normalized = singleLine ? withoutControls.replace(/\s+/g, ' ') : withoutControls.replace(/\r\n?/g, '\n')

    return normalized.trim().slice(0, maxLength)
}
